/**
 * @date:2022/10/19
 * @author 金星晖<xinghui0928@163.com, www.xinghuijin.com>
 * @copyright 南京云柜<yun-gui.com>
 * 省份数据模型
 */

import BaseModel from '@/libs/base/dataModel/BaseModel';

class RegionModel extends BaseModel {
  constructor () {
    super();
    // 省份id
    this.value = '';
    // 省份名称
    this.label = '';
    // 0：省份，1：市，2：区，3：街道
    this.type = 0;
  }

  initData (resData, modelType, needChildren) {
    this.value = resData.code;
    this.label = resData.name;
    this.type = modelType;
    if (needChildren) {
      // 除了街道没有子集，其他都有子集
      this.children = [];
      // 级联动使用
      this.loading = false;
    }
  }

  // 遍历构造器：返回单个对象
  static initModelWithData (data, modelType, needChildren) {
    const model = new this();
    model.initData(data, modelType, needChildren);
    return model;
  }

  static initListWithDataList (dataList, modelType, needChildren) {
    const list = [];
    if (dataList && Array.isArray(dataList) && dataList.length) {
      const len = dataList.length;
      for (let i = 0; i < len; i++) {
        const data = dataList[i];
        list.push(this.initModelWithData(data, modelType, needChildren));
      }
    }
    return list;
  }
}

export default RegionModel;
